import { useQuery, UseQueryOptions } from 'react-query';
import { api } from '../../api';
import { ApiProps, UserId, PartialNullable } from '../../api/types';

const QUERY_KEY = 'host-access-token';

export const useHostAccessTokenQuery = (
  { clientSecret, userId, clientId }: PartialNullable<ApiProps & UserId>,
  queryOptions?: UseQueryOptions<{ accessToken: string }>,
) =>
  useQuery(
    [QUERY_KEY, userId],
    () =>
      api.events.getHostAccessToken({
        clientSecret,
        clientId,
        userId,
      }),
    { staleTime: Infinity, ...queryOptions },
  );
